import { GroupType, GroupTypeOptions } from 'models/flexible/GroupType';
import type { Typed } from 'services/api/fields/core';

export interface DischargeReasonOptions {
  displayName?: string;
  dischargedToGroupType?: GroupTypeOptions | null;
  selectedGroupTypes?: GroupTypeOptions[];
  [key: string]: any;
}

function getDefaults(): DischargeReasonOptions {
  return {
    id: '',
    displayName: '',
    isReadmission: false,
    archived: false,
    dischargedToGroupTypeId: '',
    dischargedToGroupType: null,
    infoMessage: null,
    warningMessage: null,
  };
}

let DischargeReason: new <T extends DischargeReasonOptions>(options: T) => Typed<_DischargeReason<T>, T>;

class _DischargeReason<T extends DischargeReasonOptions = DischargeReasonOptions> {
  displayName!: string;
  dischargedToGroupType!: GroupType<NonNullable<T['dischargedToGroupType']>> | null;
  selectedGroupTypes?: GroupType<NonNullable<T['selectedGroupTypes']>[number]>[];

  constructor(options: T) {
    const opts = { ...getDefaults(), ...options };
    Object.assign(this, opts);

    this.displayName = opts.displayName ?? '';
    this.dischargedToGroupType = opts.dischargedToGroupType
      ? new GroupType<NonNullable<T['dischargedToGroupType']>>(opts.dischargedToGroupType)
      : null;
    this.selectedGroupTypes = opts.selectedGroupTypes
      ? opts.selectedGroupTypes.map((gt) => new GroupType<NonNullable<T['selectedGroupTypes']>[number]>(gt))
      : undefined;
  }

  get name() {
    return this.displayName;
  }
}

// eslint-disable-next-line prefer-const
DischargeReason = _DischargeReason as typeof DischargeReason;

export default DischargeReason;
export { DischargeReason };
export type DischargeReason<T extends DischargeReasonOptions = DischargeReasonOptions> = _DischargeReason<T> &
  Omit<T, keyof _DischargeReason<T>>;
